import { HostFamily } from '../../lib/types/models/host-family/host-family'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getHostFamily(id: number) {
  return restApiClient.url(constructApiUrl(API.hostFamilies.get.url, { id })).get<HostFamily>()
}
